module.exports = "/images/scales.svg?45788f5e03ab72777ddc0563e58ea570";